<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="iconSize"
    :height="iconSize"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="veke-icon feather feather-chevron-up"
  >
    <polyline points="18 15 12 9 6 15" />
  </svg>
</template>

<script lang="ts">
import Icon from './Icon'

export default Icon('ChevronUpIcon')
</script>
